import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '4fr 4fr 4fr 2fr 3fr 3fr 2fr 1fr',
    gap: 4,
    alignItems: 'center',
    paddingLeft: 12,
    color: 'grey',
    borderRadius: 20,
    marginBottom: 4,
    backgroundColor: theme.palette.background.default,
    textAlign: 'left',
    height: 52,
    transition: 'background-color 0.3s ease-in-out',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '8fr 3fr 1fr'
    }
  },
  adminRoot: {
    gridTemplateColumns: '4fr 4fr 4fr 4fr 2fr 3fr 3fr 2fr 1fr'
  },
  userInfoTooltipContariner: {
    padding: '9px 16px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: `0px 2px 6px 2px ${theme.palette.grey[400]}`,
    borderRadius: 5,
    width: 400
  },
  userInfoTooltipHeaderContainer: {},
  userInfoHeader: {
    paddingTop: 12,
    paddingBottom: 16
  },
  userInfoTooltipBody: {},
  userInfoEachRow: {
    display: 'grid',
    gridTemplateColumns: '8fr 1fr 20fr',
    marginTop: 4
  },
  userInfoCell: {},
  userInfoEmail: {
    cursor: 'default'
  },
  userInfoColon: {
    paddingRight: 20,
    paddingLeft: 10,
    color: theme.palette.secondary.dark
  },
  hasModalCell: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row'
  },
  skeleton: {
    marginTop: '14px!important',
    marginBottom: '14px!important',
    width: '80%'
  }
}))
export default useStyles
